import { Takeover, TakeoverPropsStrict } from '@servicetitan/design-system';
import classNames from 'classnames';
import omit from 'lodash.omit';
import { FC, ReactElement } from 'react';
import * as Styles from './takeover.module.less';

type PortalTakeoverTheme = 'light' | 'dark' | 'white' | 'combined' | 'grey';
export interface PortalTakeoverProps extends Omit<TakeoverPropsStrict, 'theme'> {
    mobile: boolean;
    header?: ReactElement;
    theme?: PortalTakeoverTheme;
}

const takeoverThemeClasses: Record<PortalTakeoverTheme, string> = {
    light: '',
    dark: '',
    white: Styles.takeoverThemeWhite,
    combined: Styles.takeoverThemeWhiteSmooth,
    grey: Styles.takeoverThemeGrey,
};

const PortalTakeoverComponent: FC<PortalTakeoverProps> = props => {
    const takeoverProps = omit(props, ['theme', 'mobile', 'header']);
    const themeClass = props.theme ? takeoverThemeClasses[props.theme] : undefined;
    const takeoverTheme = props.theme === 'dark' ? 'dark' : 'light';

    return (
        <Takeover
            {...takeoverProps}
            theme={takeoverTheme}
            className={classNames(
                props.mobile ? Styles.takeoverMobile : Styles.takeoverDesktop,
                themeClass,
                props.className
            )}
        >
            {!!props.header && (
                <Takeover.Header
                    title={props.header}
                    backLabel=""
                    theme={takeoverTheme}
                    className="p-t-0-i min-h-0-i"
                />
            )}
            {props.children}
        </Takeover>
    );
};

export const PortalTakeover = Object.assign(PortalTakeoverComponent, {
    Section: Takeover.Section,
});
